import type { LayerRow } from '../../masterdependency/framework';

type Props = { items?: LayerRow[] };

export function ImplementationLayersPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.layer} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-xs text-slate-400">Layer {item.layer}</p>
              <p className="text-sm font-medium">{item.name}</p>
            </div>
            <div className="text-right">
              <p className="text-lg font-semibold text-brand-600">{item.modules}</p>
              <p className="text-xs text-slate-500">{item.status}</p>
            </div>
          </div>
          <div className="mt-2 h-1.5 rounded-full bg-slate-100 dark:bg-slate-800">
            <div className="h-1.5 rounded-full bg-brand-500" style={{ width: `${item.progress}%` }} />
          </div>
        </div>
      ))}
    </div>
  );
}
